export const styleDefaults = {
  fontFamily: 'OpenSans',
  fontSize: 11,
  fontColor: '#000000',
  backgroundColor: '#FFFFFF',
  backgroundColorOpacity: 0,
  horizontalAlignment: 'left',
  verticalAlignment: 'top',
  lineHeight: 1.25,
  fontStyle: 'normal',
  fontWeight: 400,
  textDecoration: 'none',
}
